<div *ngIf="mortgage$ | async as mortgage">
	<div section-content class="justify-between space-y-4">
		<ui-info-row infoLabel="Charge Type" [infoValue]="mortgage?.chargeType" />
		<ui-info-row
			infoLabel="Standard Charge Term #"
			[infoValue]="mortgage?.standardChargeTerm"
		></ui-info-row>
		<ui-info-row
			infoLabel="Loan Reference #"
			[infoValue]="mortgage?.referenceNumber"
		></ui-info-row>
		<div class="flex flex-row justify-between">
			<span class="text-gray-950 flex items-center w-full">Closing Date:</span>
			<app-sale-closing-date class="w-full" label=""></app-sale-closing-date>
		</div>
		<ui-info-row
			infoLabel="Lender Comments"
			[infoValue]="mortgage?.lenderComment"
		></ui-info-row>
		<ui-info-row
			infoLabel="Priority"
			*ngIf="mortgage?.transactionType !== transactionType.BRIDGE"
		>
			<div
				class="space-x-2 flex flex-row items-center align-middle justify-between"
			>
				<span class="text-gray-500">{{
					(mortgage?.priority ? (mortgage?.priority | ordinalSuffix) : '') +
						' Priority'
				}}</span>
				<ui-button
					actions
					(click)="editPriority()"
					icon="edit"
					preset="ICON_DEFAULT"
					size="sm"
				></ui-button>
			</div>
		</ui-info-row>
	</div>
</div>
